import { Fragment, useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ChevronDown, ChevronRight, RefreshCcw } from "lucide-react";
import { toast } from "sonner";

const TONE = {
  ok: "bg-emerald-100 text-emerald-700 border-emerald-200",
  test: "bg-sky-100 text-sky-700 border-sky-200",
  duplicate: "bg-amber-100 text-amber-700 border-amber-200",
  rejected: "bg-rose-100 text-rose-700 border-rose-200",
};

const LogRow = ({ e }) => {
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      <tr className="border-t border-slate-100 align-top cursor-pointer hover:bg-slate-50" onClick={() => setOpen(!open)} data-testid={`intake-log-row-${e.id}`}>
        <td className="px-2 py-2 whitespace-nowrap">{open ? <ChevronDown className="w-3 h-3 inline" /> : <ChevronRight className="w-3 h-3 inline" />} {fmtDateTime(e.created_at)}</td>
        <td className="px-2 py-2"><Badge className={TONE[e.status] || ""}>{e.status}</Badge></td>
        <td className="px-2 py-2 max-w-[240px]">{e.reason}</td>
        <td className="px-2 py-2">{e.email || "—"}</td>
        <td className="px-2 py-2 font-mono">{e.external_reference || "—"}</td>
        <td className="px-2 py-2 font-mono">{e.order_number || "—"}</td>
        <td className="px-2 py-2 font-mono">{e.ip}{e.via ? ` · ${e.via}` : ""}</td>
      </tr>
      {open && (
        <tr><td colSpan={7} className="px-2 pb-2">
          <pre className="bg-slate-50 border border-slate-200 rounded p-2 text-[11px] overflow-auto max-h-64" data-testid={`intake-log-raw-${e.id}`}>{JSON.stringify(e.raw_payload, null, 2)}</pre>
        </td></tr>
      )}
    </Fragment>
  );
};

export const IntakeLogSection = () => {
  const [items, setItems] = useState(null);
  const [hidden, setHidden] = useState(false);
  const load = async () => {
    try { const r = await api.get("/intake-log?limit=100"); setItems(r.data); }
    catch (err) { if (err?.response?.status === 403) setHidden(true); else toast.error("Intake-Protokoll konnte nicht geladen werden."); }
  };
  useEffect(() => { load(); }, []);
  if (hidden) return null;
  return (
    <div className="border border-slate-200 rounded-md p-3 space-y-2" data-testid="intake-log-section">
      <div className="flex items-center justify-between">
        <div className="text-sm font-medium text-slate-700">Letzte Webhook-Versuche {items && <span className="text-xs text-slate-400">({items.length})</span>}</div>
        <Button size="sm" variant="outline" onClick={load} data-testid="intake-log-refresh"><RefreshCcw className="w-3.5 h-3.5 mr-1" /> Aktualisieren</Button>
      </div>
      {items?.length === 0 && <p className="text-xs text-slate-500" data-testid="intake-log-empty">Noch keine Website-Übertragungen protokolliert.</p>}
      {items?.length > 0 && (
        <div className="overflow-x-auto max-h-[420px]">
          <table className="w-full text-xs" data-testid="intake-log-table">
            <thead className="text-left text-slate-500"><tr>
              <th className="px-2 py-1">Zeit</th><th className="px-2 py-1">Status</th><th className="px-2 py-1">Grund</th><th className="px-2 py-1">E-Mail</th>
              <th className="px-2 py-1">Referenz</th><th className="px-2 py-1">Auftrag</th><th className="px-2 py-1">IP · Token-Weg</th>
            </tr></thead>
            <tbody>{items.map((e) => <LogRow key={e.id} e={e} />)}</tbody>
          </table>
        </div>
      )}
      <p className="text-[11px] text-slate-400">Zeile anklicken für die Rohdaten. Token-Felder werden vor dem Speichern entfernt; es werden max. 500 Einträge / 90 Tage aufbewahrt.</p>
    </div>
  );
};
